/** Mirrors common-ui/lib/common/Constant action types used by the shell reducers. */
export const USER_DETAILS = 'USER_DETAILS';
export const USER_ROLES = 'USER_ROLES';
export const USER_SUBSCRIPTION = 'USER_SUBSCRIPTION';
export const CURRENT_APP = 'CURRENT_APP';
